export default "__VITE_ASSET__iHW1PHLQ__"